<p-dialog
  header="Signature Failed"
  [(visible)]="showFileCorruptedDialog"
  [style]="{ width: '500px', maxWidth: '90vw', height: '35vh' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <div class="p-1 text-center">
    <i
      class="pi pi-exclamation-triangle"
      style="font-size: 2.5rem; color: #ff7b00"
    ></i>
    <h6 class="mt-2 mb-2">Signature capture unsuccessful. Please try again.</h6>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      class="mt-2"
      label="Try Again"
      icon="pi pi-refresh"
      (onClick)="onRetryClicked()"
      styleClass="try-button"
    >
    </p-button>
  </ng-template>
</p-dialog>

<div *ngIf="isLoading" class="loading-overlay">
  <div class="loader-content">
    <img
      src="/assets/img/doqfy-load.gif"
      style="height: 120px"
      alt="Loading..."
    />
    <p style="color: #ffffff">Your data is getting prepared...</p>
  </div>
</div>

<div class="d-flex justify-content-center align-items-center">
  <!-- AADHAAR method -->
  <p-button
    *ngIf="selectMethod === 'AADHAAR'"
    label="Sign Now"
    (click)="loadEsignData(emudhraSign)"
    styleClass="p-button-sm-outline m-3"
  >
  </p-button>

  <!-- DSC method -->
  <p-button
    *ngIf="selectMethod === 'DSC'"
    label="Sign Now"
    (click)="loadEsignDataDSC()"
    styleClass="p-button-sm-outline m-3"
  >
  </p-button>
</div>

<ng-template #emudhraSign let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">Aadhaar Validation</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeEmudhraModel()"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-content">
    <div class="modal-body" style="background-color: #f3eeee; height: 100%">
      <iframe
        [src]="pdfSource"
        sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation"
        allow="local-network-access"
        class="col-md-12 text-center this-is-iframe"
        style="
          width: 100%;
          height: 80vh;
          border: 1px solid #ccc;
          background-color: #ffffff;
          zoom: 1;
        "
      >
      </iframe>
    </div>
  </div>
</ng-template>

<ng-template #emudhraSignDSC let-modal>
  <div class="modal-header">
    <h4 class="title_five" id="modal-basic-title">DSC Validation</h4>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      (click)="closeEmudhraModel()"
      aria-label="Close"
    ></button>
  </div>

  <div class="modal-content">
    <div class="modal-body" style="background-color: #f3eeee; height: 100%">
      <div style="text-align: center">
        <strong class="r1s_small"
          >You are being redirected to emSigner portal</strong
        ><br />
        <strong class="r1s_small" style="color: blue; margin: 1rem 0rem">
          Please wait ... </strong
        ><br />
        <strong class="r1s_small">
          (Please do not press 'Refresh' or 'Back' button)
        </strong>
      </div>

      <!-- Hidden form — auto-submitted after 3 s via setInterval in component -->
      <form
        id="signDocForm"
        name="signDocForm"
        method="post"
        [action]="pdfSource"
        (ngSubmit)="submitForm()"
      >
        <input
          type="hidden"
          name="Parameter1"
          id="Parameter1"
          [value]="parameters?.Parameter1"
        />
        <input
          type="hidden"
          name="Parameter2"
          id="Parameter2"
          [value]="parameters?.Parameter2"
        />
        <input
          type="hidden"
          name="Parameter3"
          id="Parameter3"
          [value]="parameters?.Parameter3"
        />
      </form>
    </div>
  </div>
</ng-template>
